<template>
  <a-config-provider>
    <a-style-provider hash-priority="low">
      <div class="text-white" :class="fill ? `flex flex-1 ${wrapperClass}` : wrapperClass">
        <a-button
          v-if="spin"
          v-bind="$attrs"
          :loading="true"
          html-type="button"
          :type="buttonType"
          :class="[resetStyles ? '' : 'h-auto text-white flex-1 cursor-not-allowed btn-loading', btnclass]"
        >
          <!--
          <span class="spinner">
            <span class="bounce1"></span>
            <span class="bounce2"></span>
            <span class="bounce3"></span>
          </span>-->
        </a-button>
        <a-button
          v-else-if="!enabled"
          v-bind="$attrs"
          html-type="button"
          :disabled="true"
          :type="buttonType"
          :class="[resetStyles ? '' : 'h-auto text-gray-600 flex-1 cursor-not-allowed', btnclass]"
        >
          <template v-if="iconSlotPassed" #icon>
            <slot name="icon" />
          </template>
          <slot />
        </a-button>
        <a-button
          v-else-if="type == 'submit'"
          v-bind="$attrs"
          html-type="submit"
          :type="buttonType"
          @click="$emit('click')"
          :class="[resetStyles ? '' : 'h-auto text-white flex-1 text-center cursor-pointer', btnclass]"
        >
          <template v-if="iconSlotPassed" #icon>
            <slot name="icon" />
          </template>
          <slot />
        </a-button>
        <a-button
          v-else
          v-bind="$attrs"
          html-type="button"
          :type="buttonType"
          @click="$emit('click')"
          :class="[resetStyles ? '' : 'h-auto text-white flex-1', btnclass]"
        >
          <template v-if="iconSlotPassed" #icon>
            <slot name="icon" />
          </template>
          <slot />
        </a-button>
      </div>
    </a-style-provider>
  </a-config-provider>
  <a-config-provider>
    <a-style-provider hash-priority="low"> </a-style-provider>
  </a-config-provider>
</template>

<script>
import FormAntdButton from './AntDesign/FormAntdButton.vue'

/**
 * Default button component.
 */
export default {
  name: 'FormButton',
  components: {
    // FormAntdButton - removed, using a-button directly
  },
  inheritAttrs: false,
  props: {
    /**
     * Set of css classes to apply on the button.
     */
    classes: {
      type: String,
      default: ''
    },
    /**
     * Set of css class to button wrapper.
     */
    wrapperClass: {
      type: String,
      default: ''
    },
    /**
     * Type of button should be either 'button' or 'submit'.
     */
    type: {
      type: String,
      default: 'button'
    },
    /**
     * Toggle whether button should fill the remaining space horizontally.
     */
    fill: {
      type: Boolean,
      default: false
    },
    /**
     * Show spinner icon instead of button text. Useful for triggering after the button is clicked while loading or submitting data.
     */
    spin: {
      type: Boolean,
      default: false
    },
    /**
     * set ant design type of button, it can be either 'primary', 'ghost', 'dashed', 'link', 'text', or 'default'.
     */
    buttonType: {
      type: String,
      default: 'primary'
    },
    /**
     * Enable or disable the button. Setting this to false will gray out the button and disable any click events.
     */
    enabled: {
      type: Boolean,
      default: true
    },
    /**
     * Reset button styles. Setting this to true will reset helping component styles, it will require to set all styles on the classes prop.
     */
    resetStyles: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    iconSlotPassed() {
      return !!(this.$slots.icon && this.$slots.icon())
    },
    disabled() {
      return !this.enabled
    },
    btnclass() {
      let newClasses = ''
      let classes = this.classes.trim().split(' ')

      classes.forEach((cls) => {
        if (cls.startsWith('bg-')) {
          if (this.enabled) {
            let c = cls.split('-')
            let color = c[1]
            let weight = parseInt(c[2]) == 50 ? 100 : parseInt(c[2])
            let hover = `hover:bg-${color}-${parseInt(weight) + 100}`
            let active = `active:bg-${color}-${parseInt(weight) - 100}`
            newClasses += `${cls} ${hover} ${active} `
          }
        } else {
          newClasses += `${cls} `
        }
      })

      if (!this.enabled) {
        newClasses += 'bg-gray-300 hover:bg-gray-400 active:bg-gray-400'
      }

      return newClasses?.trim()
    }
  }
}
</script>

<style scoped>
.btn-loading {
  padding: 4px;
  width: 70px;
  text-align: center;
  display: block;
}
.spinner {
  margin: 9px auto 7px auto;
  width: 70px;
  text-align: center;
  display: block;
}
.spinner > span {
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}
.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}
@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
